
import EthereumLogo from './Images/Blockchains/Ethereum.png';
import AvalancheLogo from './Images/Blockchains/AvalancheLogo.png';
import PolygonLogo from './Images/Blockchains/Polygon.png';
import IotaLogo from './Images/Blockchains/IotaLogo.png';

import UNISWAP_LOGO from './Images/dapps/UniSwapLogo.svg';

import USDC_LOGO from './Images/Tokens/USDC.png';
import SurfDummy_LOGO from './Images/Tokens/SurfDummy_LOGO.png';
import EURe_LOGO from './Images/Tokens/EURe.svg';

const abiDappOne = {EMPTY:"EMPTY"}
const abiGlobal = {EMPTY:"EMPTY"}

// Define constants for chain IDs
export const CHAIN_IDS = {
    ETHEREUM: 1,
    POLYGON: 2,
    BSC: 3,
    TAIKO: 4,
    MANTA: 5,
    AVALANCHE: 6,
    ARBITRUM: 7,
    LINEA: 8,
    METIS: 9,
    OPTIMISM: 10,
    POLYGONZKEVM: 11,
    ZKSYNCERA: 12,
    SCROLL: 13,
    FUTURVERSE: 14,
    MANTLE: 15,
    BASE: 16,
    FANTOM: 17,
    CELO: 18,
    OASIS_SAPPHIRE: 19,
    EVMOS: 20,
    CRONOS: 21,
    ASTAR: 22,
    IOTAEVM: 23
};

export const CHAIN_CONNECTIONS = {
    [CHAIN_IDS.ETHEREUM]: {
        name: "Ethereum",
        networkName: "Ethereum Sepolia",
        networkId: 11155111,
        networkIdHex: "0xaa36a7",
        contractGlobal: "0x46730f7087F290C39b3ED1eB4cA81ce48664B9ac",
        abiGLobal: abiGlobal,
        link: "https://sepolia.etherscan.io/tx/",
        linkAddress: "https://sepolia.etherscan.io/address/",
        supportedTokens: [],
        logo: EthereumLogo,
        dAppsInfo: [
            {
                address: "0x60Fd6f59080dC38643D8A0861cE2c52D828E3Ebe",
                abiDapp: abiDappOne,
                created: 3494952
            }
        ]
    },
    [CHAIN_IDS.POLYGON]: {
        active: true,
        name: "Polygon",
        networkName: "Polygon Amoy",
        networkId: 80002,
        networkIdHex: "0x13882",
        contractGlobal: "0x4Faf70E7479dA861441e43721fA1E90a109d1805", //Mixer contract
        link: "https://www.oklink.com/amoy/tx/",
        linkAddress: "https://www.oklink.com/amoy/address/",
        universalUP:
            [
                {
                    version: "v1",
                    address: "0xA953D246D93c64B874217231108e5e4100C57B51",
                    globalHash: "0xe7152352d5b3d8ff2885f35ce0fc2288968bd3805bd143d613ce4923e9dee3e4",
                    abi: "ABI"
                }
            ],
        supportedDapps: [
            {
                name: "Native Transfer",
                logo: "NaN",
                functions: [
                    {
                        header: "function transferEth(address targetAddress, uint256 amount)",
                        name: "transferEth"
                    }
                ],
                address: "0x6A37688Dc38b1bCCEE5D867873d2eb960C6B1d31" // Proxy contract
            },
            {
                name: "ERC20 Transfer",
                logo: "NaN",
                functions: [
                    {
                        header: "function transfer(address recipient, uint256 amount)",
                        name: "transfer"
                    }
                ]
            },
            {
                name: "UniSwap Swap",
                logo: UNISWAP_LOGO,
                functions: [
                    {   // Approve to cal from the ERC20 standards
                        header: "function approve(address spender, uint256 amount)",
                        name: "approve"
                    },
                    {   // Permit2 funciton to call from UniSwap protocol
                        header: "function approve(address token, address spender, uint160 amount, uint48 expiration)",
                        name: "approve"
                    },
                    {   // Swap function to call from UniSwap
                        header: "function execute(bytes calldata commands, bytes[] calldata inputs)",
                        name: "execute"
                    },
                    {   // Unrwap wETH
                        header: "function transferEthFromAnUnwrapped(address targetAddress,address tokenWrapped)",
                        name: "transferEthFromAnUnwrapped"
                    }
                ],
                address: "" // CHANGE THIS
            }
        ],
        supportedTokens: [
            {
                name: "USDC",
                address: "0x41e94eb019c0762f9bfcf9fb1e58725bfb0e7582",
                logo: USDC_LOGO,
                decimals: 6
            },
            {
                name: "EURe",
                address: "0xF011267f494Cf371CCd8016927723065072615A9",
                logo: EURe_LOGO,
                decimals: 18
            },
            {
                name: "SurfDummy",
                address: "0xf60928e4faF7015c6e1144603150FF0D77540847",
                logo: SurfDummy_LOGO,
                decimals: 18
            }
        ],
        supportedUniSwapTokens: [
            {
                name: "MATIC",
                address: "", // This is the address that UniSwap implements for wMatic //0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889
                logo: PolygonLogo,
                decimals: 18
            },
            {
                name: "USDC",
                address: "0x41e94eb019c0762f9bfcf9fb1e58725bfb0e7582",
                logo: USDC_LOGO,
                decimals: 6
            }
        ],
        logo: PolygonLogo
    },
    [CHAIN_IDS.BSC]: {
        name: "Binance Smart Chain",
        networkName: "Binance Smart Test Chain",
        networkId: 97,
        networkIdHex: "0x61",
        contractGlobal: "0x980c43C046F7B14A5eFE774f4958e7680dE365da",
        abiGLobal: abiGlobal,
        link: "https://testnet.bscscan.com/tx/",
        linkAddress: "https://testnet.bscscan.com//address/",
        dAppsInfo: [
            {
                address: "0x59e0CBfc13d5FeD1386C814B1D5477Ea723Da37f",
                abiDapp: abiDappOne,
                created: 30563523,
            }
        ]
    },
    [CHAIN_IDS.TAIKO]: {
        name: "Taiko",
        networkName: "Taiko Jolnir",
        networkId: 167007,
        networkIdHex: "0x28C5F",
        contractGlobal: "0xD50eCE0eB75c448c5c158ce78a7a15beC45130Be",
        abiGLobal: abiGlobal,
        link: "https://explorer.jolnir.taiko.xyz/tx/",
        linkAddress: "https://explorer.jolnir.taiko.xyz/address/",
        dAppsInfo: [
            {
                address: "0x50bCe66687fabB3ed18c8E7C2F9425B938D53aCD",
                abiDapp: abiDappOne,
                created: 2741
            }
        ]
    },
    [CHAIN_IDS.MANTA]: {
        name: "Manta",
        networkName: "Manta Pacific",
        networkId: 3441005,
        networkIdHex: "0x34816D",
        contractGlobal: "0xD50eCE0eB75c448c5c158ce78a7a15beC45130Be",
        abiGLobal: abiGlobal,
        link: "https://pacific-explorer.manta.network/tx/",
        linkAddress: "https://pacific-explorer.manta.network/address/",
        dAppsInfo: [
            {
                address: "0x50bCe66687fabB3ed18c8E7C2F9425B938D53aCD",
                abiDapp: abiDappOne,
                created: 282655
            }
        ]
    },
    [CHAIN_IDS.AVALANCHE]: {
        active: false,
        name: "Avalanche",
        networkName: "Avalanche Fuji",
        networkId: 43113,
        networkIdHex: "0xA869",
        contractGlobal: "0x3C249BaED1AAaA0Fec957fF63B1E17Aa55853F9B", //Mixer contract
        link: "https://testnet.snowtrace.io/tx/",
        linkAddress: "https://testnet.snowtrace.io/address/",
        universalUP:
            [
                {
                    version: "v1",
                    address: "0xcaBC0A005F108C90f3d63Ab00203A9087C2C8061",
                    globalHash: "0x9ea697b05c639c31624dcc0f37d1fc029c836471bc4fe617b4a1a8a595f3823f",
                    abi: "ABI"
                }
            ],
        supportedDapps: [
            {
                name: "Native Transfer",
                logo: "NaN",
                functions: [
                    {
                        header: "function transferEth(address targetAddress, uint256 amount)",
                        name: "transferEth"
                    }
                ],
                address: "0x6Cd91148a2F6ebFFf4DD7B7a23e19Df21F41191B" // Proxy contract
            },
            {
                name: "ERC20 Transfer",
                logo: "NaN",
                functions: [
                    {
                        header: "function transfer(address recipient, uint256 amount)",
                        name: "transfer"
                    }
                ]
            },
            {
                name: "UniSwap Swap",
                logo: UNISWAP_LOGO,
                functions: [
                    {   // Approve to cal from the ERC20 standards
                        header: "function approve(address spender, uint256 amount)",
                        name: "approve"
                    },
                    {   // Permit2 funciton to call from UniSwap protocol
                        header: "function approve(address token, address spender, uint160 amount, uint48 expiration)",
                        name: "approve"
                    },
                    {   // Swap function to call from UniSwap
                        header: "function execute(bytes calldata commands, bytes[] calldata inputs)",
                        name: "execute"
                    },
                    {   // Unrwap wETH
                        header: "function transferEthFromAnUnwrapped(address targetAddress,address tokenWrapped)",
                        name: "transferEthFromAnUnwrapped"
                    }
                ],
                address: "" // CHANGE THIS
            }
        ],
        supportedTokens: [
            {
                name: "USDC",
                address: "0x5425890298aed601595a70ab815c96711a31bc65",
                logo: USDC_LOGO,
                decimals: 6
            },
            {
                name: "SurfDummy",
                address: "0x59f0Aa9Fe18317dBD01945766C539d9D51B57496",
                logo: SurfDummy_LOGO,
                decimals: 18
            }
        ],
        supportedUniSwapTokens: [
            {
                name: "AVAX",
                address: "", // This is the address that UniSwap implements for wMatic //0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889
                logo: AvalancheLogo,
                decimals: 18
            },
            {
                name: "USDC",
                address: "0x41e94eb019c0762f9bfcf9fb1e58725bfb0e7582",
                logo: USDC_LOGO,
                decimals: 6
            }
        ],
        logo: AvalancheLogo
    },
    [CHAIN_IDS.ARBITRUM]: {
        name: "Arbitrum",
        networkName: "Arbitrum Goerli",
        networkId: 421613,
        networkIdHex: "0x66EED",
        contractGlobal: "0xD50eCE0eB75c448c5c158ce78a7a15beC45130Be",
        abiGLobal: abiGlobal,
        link: "https://goerli.arbiscan.io/tx/",
        linkAddress: "https://goerli.arbiscan.io/address/",
        dAppsInfo: [
            {
                address: "0x50bCe66687fabB3ed18c8E7C2F9425B938D53aCD",
                abiDapp: abiDappOne,
                created: 33696599
            }
        ]
    },
    [CHAIN_IDS.LINEA]: {
        name: "Linea",
        networkName: "Linea Goerli",
        networkId: 59140,
        networkIdHex: "0xE704",
        contractGlobal: "0x50bCe66687fabB3ed18c8E7C2F9425B938D53aCD",
        abiGLobal: abiGlobal,
        link: "https://goerli.lineascan.build/tx/",
        linkAddress: "https://goerli.lineascan.build/address/",
        dAppsInfo: [
            {
                address: "0xBA063e20e3a752F8613784BE460DFc42ec33f279",
                abiDapp: abiDappOne,
                created: 1316245
            }
        ]
    },
    [CHAIN_IDS.METIS]: {
        name: "Metis",
        networkName: "Metis Goerli",
        networkId: 599,
        networkIdHex: "0x257",
        contractGlobal: "0xD50eCE0eB75c448c5c158ce78a7a15beC45130Be",
        abiGLobal: abiGlobal,
        link: "https://goerli.explorer.metisdevops.link/tx/",
        linkAddress: "https://goerli.explorer.metisdevops.link/address/",
        dAppsInfo: [
            {
                address: "0x50bCe66687fabB3ed18c8E7C2F9425B938D53aCD",
                abiDapp: abiDappOne,
                created: 1940390
            }
        ]
    },
    [CHAIN_IDS.OPTIMISM]: {
        name: "Optimism",
        networkName: "Optimism Goerli",
        networkId: 420,
        networkIdHex: "0x1A4",
        contractGlobal: "0xeFc1d04AB2A90581A961bA56e26BbB16ce4eF3cA",
        abiGLobal: abiGlobal,
        link: "https://goerli-optimism.etherscan.io/tx/",
        linkAddress: "https://goerli-optimism.etherscan.io/address/",
        dAppsInfo: [
            {
                address: "0x762aa334cEA5459F0D574599421890ac1531Ab8D",
                abiDapp: abiDappOne,
                created: 13216547
            }
        ]
    },
    [CHAIN_IDS.POLYGONZKEVM]: {
        name: "PolygonZkEvm",
        networkName: "PolygonZkEvm TestNet",
        networkId: 1442,
        networkIdHex: "0x5A2",
        contractGlobal: "0x8eeF6461Ca83F66a398C9B996b6488a793a54ebd",
        abiGLobal: abiGlobal,
        link: "https://testnet-zkevm.polygonscan.com/tx/",
        linkAddress: "https://testnet-zkevm.polygonscan.com/address/",
        dAppsInfo: [
            {
                address: "0xDf18CA2e11e1D3d1eA3573a6ccF2C65D64da71F5",
                abiDapp: abiDappOne,
                created: 2035589
            }
        ]
    },
    [CHAIN_IDS.ZKSYNCERA]: {
        name: "ZkSyncEra",
        networkName: "ZkSyncEra TestNet",
        networkId: 280,
        networkIdHex: "0x118",
        contractGlobal: "0x60e92Ce0D0B21635A668934b942427625daF53d4",
        abiGLobal: abiGlobal,
        link: "https://goerli.explorer.zksync.io/tx/",
        linkAddress: "https://goerli.explorer.zksync.io/address/",
        dAppsInfo: [
            {
                address: "0x15D70cAF647eFFD632d05422C44EE09775CdaeCE",
                abiDapp: abiDappOne,
                created: 10571095
            }
        ]
    },
    [CHAIN_IDS.SCROLL]: {
        name: "Scroll",
        networkName: "Scroll Sepolia",
        networkId: 534351,
        networkIdHex: "0x8274F",
        contractGlobal: "0xD50eCE0eB75c448c5c158ce78a7a15beC45130Be",
        abiGLobal: abiGlobal,
        link: "https://sepolia-blockscout.scroll.io/tx/",
        linkAddress: "https://sepolia-blockscout.scroll.io/address/",
        dAppsInfo: [
            {
                address: "0x50bCe66687fabB3ed18c8E7C2F9425B938D53aCD",
                abiDapp: abiDappOne,
                created: 12717
            }
        ]
    },
    [CHAIN_IDS.FUTURVERSE]: {
        name: "Futurverse",
        networkName: "Futurverse Porcini",
        networkId: 7672,
        networkIdHex: "0x1DF8",
        contractGlobal: "0x2A26757847B7165c864A35405be419C2856eC0a6",
        abiGLobal: abiGlobal,
        link: "https://explorer.rootnet.cloud/tx/",
        linkAddress: "https://explorer.rootnet.cloud/address/",
        dAppsInfo: [
            {
                address: "0x68bD463Ee8Ffa8C64349d701397427958D6065Af",
                abiDapp: abiDappOne,
                created: 7087932
            }
        ]
    },
    [CHAIN_IDS.MANTLE]: {
        name: "Mantle",
        networkName: "Mantle Testnet",
        networkId: 5001,
        networkIdHex: "0x1389",
        contractGlobal: "0xD50eCE0eB75c448c5c158ce78a7a15beC45130Be",
        abiGLobal: abiGlobal,
        link: "https://explorer.testnet.mantle.xyz/tx/",
        linkAddress: "https://explorer.testnet.mantle.xyz/address/",
        dAppsInfo: [
            {
                address: "0x50bCe66687fabB3ed18c8E7C2F9425B938D53aCD",
                abiDapp: abiDappOne,
                created: 18437706
            }
        ]
    },
    [CHAIN_IDS.BASE]: {
        name: "Base",
        networkName: "Base Goerli",
        networkId: 84531,
        networkIdHex: "0x14A33",
        contractGlobal: "0x2A26757847B7165c864A35405be419C2856eC0a6",
        abiGLobal: abiGlobal,
        link: "https://goerli.basescan.org/tx/",
        linkAddress: "https://goerli.basescan.org/address/",
        dAppsInfo: [
            {
                address: "0xBA063e20e3a752F8613784BE460DFc42ec33f279",
                abiDapp: abiDappOne,
                created: 8886882
            }
        ]
    },
    [CHAIN_IDS.FANTOM]: {
        name: "Fantom",
        networkName: "Fantom Testnet",
        networkId: 4002,
        networkIdHex: "0xFA2",
        contractGlobal: "0xD50eCE0eB75c448c5c158ce78a7a15beC45130Be",
        abiGLobal: abiGlobal,
        link: "https://testnet.ftmscan.com/tx/",
        linkAddress: "https://testnet.ftmscan.com/address/",
        dAppsInfo: [
            {
                address: "0x50bCe66687fabB3ed18c8E7C2F9425B938D53aCD",
                abiDapp: abiDappOne,
                created: 19985745
            }
        ]
    },
    [CHAIN_IDS.CELO]: {
        name: "Celo",
        networkName: "Celo Alfajores",
        networkId: 44787,
        networkIdHex: "0xAEF3",
        contractGlobal: "0xD50eCE0eB75c448c5c158ce78a7a15beC45130Be",
        abiGLobal: abiGlobal,
        link: "https://explorer.celo.org/alfajores/tx/",
        linkAddress: "https://explorer.celo.org/alfajores/address/",
        dAppsInfo: [
            {
                address: "0x50bCe66687fabB3ed18c8E7C2F9425B938D53aCD",
                abiDapp: abiDappOne,
                created: 19532412
            }
        ]
    },
    [CHAIN_IDS.OASIS_SAPPHIRE]: {
        name: "Oasis",
        networkName: "Oasis Sapphire Testnet",
        networkId: 23295,
        networkIdHex: "0x5AFF",
        contractGlobal: "0xD50eCE0eB75c448c5c158ce78a7a15beC45130Be",
        abiGLobal: abiGlobal,
        link: "https://testnet.explorer.sapphire.oasis.dev/tx/",
        linkAddress: "https://testnet.explorer.sapphire.oasis.dev/address/",
        dAppsInfo: [
            {
                address: "0x50bCe66687fabB3ed18c8E7C2F9425B938D53aCD",
                abiDapp: abiDappOne,
                created: 2362043
            }
        ]
    },
    [CHAIN_IDS.EVMOS]: {
        name: "Evmos",
        networkName: "Evmos Testnet",
        networkId: 9000,
        networkIdHex: "0x2328",
        contractGlobal: "0xD50eCE0eB75c448c5c158ce78a7a15beC45130Be",
        abiGLobal: abiGlobal,
        link: "https://testnet.escan.live/tx/",
        linkAddress: "https://testnet.escan.live/address/",
        dAppsInfo: [
            {
                address: "0x50bCe66687fabB3ed18c8E7C2F9425B938D53aCD",
                abiDapp: abiDappOne,
                created: 16843787
            }
        ]
    },
    [CHAIN_IDS.CRONOS]: {
        name: "Cronos",
        networkName: "Cronos Testnet",
        networkId: 338,
        networkIdHex: "0x152",
        contractGlobal: "0x68bD463Ee8Ffa8C64349d701397427958D6065Af",
        abiGLobal: abiGlobal,
        link: "https://explorer.cronos.org/testnet/tx/",
        linkAddress: "https://explorer.cronos.org/testnet/address/",
        dAppsInfo: [
            {
                address: "0xf60928e4faF7015c6e1144603150FF0D77540847",
                abiDapp: abiDappOne,
                created: 12703017
            }
        ]
    },
    [CHAIN_IDS.ASTAR]: {
        name: "Astar",
        networkName: "Astar Shibuya",
        networkId: 81,
        networkIdHex: "0x51",
        contractGlobal: "0xD50eCE0eB75c448c5c158ce78a7a15beC45130Be",
        abiGLobal: abiGlobal,
        link: "https://blockscout.com/shibuya/tx/",
        linkAddress: "https://blockscout.com/shibuya/address/",
        dAppsInfo: [
            {
                address: "0x50bCe66687fabB3ed18c8E7C2F9425B938D53aCD",
                abiDapp: abiDappOne,
                created: 4569330
            }
        ]
    },
    [CHAIN_IDS.IOTAEVM]: {
        active: false,
        name: "IOTA",
        networkName: "IOTA EVM Testnet",
        networkId: 1075,
        networkIdHex: "0x433",
        contractGlobal: "0xf60928e4faF7015c6e1144603150FF0D77540847", //Mixer contract
        link: "https://explorer.evm.testnet.iotaledger.net/tx/",
        linkAddress: "https://explorer.evm.testnet.iotaledger.net/address/",
        universalUP:
            [
                {
                    version: "v1",
                    address: "0x980c43C046F7B14A5eFE774f4958e7680dE365da",
                    globalHash: "0x214d5d231a2511d8d0958ce38623f22cc385067bdf4f6ebdb6cc0e0d8a6aba6f",
                    abi: "ABI"
                }
            ],
        supportedDapps: [
            {
                name: "Native Transfer",
                logo: "NaN",
                functions: [
                    {
                        header: "function transferEth(address targetAddress, uint256 amount)",
                        name: "transferEth"
                    }
                ],
                address: "0x68bD463Ee8Ffa8C64349d701397427958D6065Af" // Proxy contract
            },
            {
                name: "ERC20 Transfer",
                logo: "NaN",
                functions: [
                    {
                        header: "function transfer(address recipient, uint256 amount)",
                        name: "transfer"
                    }
                ]
            },
            {
                name: "UniSwap Swap",
                logo: UNISWAP_LOGO,
                functions: [
                    {   // Approve to cal from the ERC20 standards
                        header: "function approve(address spender, uint256 amount)",
                        name: "approve"
                    },
                    {   // Permit2 funciton to call from UniSwap protocol
                        header: "function approve(address token, address spender, uint160 amount, uint48 expiration)",
                        name: "approve"
                    },
                    {   // Swap function to call from UniSwap
                        header: "function execute(bytes calldata commands, bytes[] calldata inputs)",
                        name: "execute"
                    },
                    {   // Unrwap wETH
                        header: "function transferEthFromAnUnwrapped(address targetAddress,address tokenWrapped)",
                        name: "transferEthFromAnUnwrapped"
                    }
                ],
                address: "" // CHANGE THIS
            }
        ],
        supportedTokens: [
            {
                name: "SurfDummy",
                address: "0x14fB07aBc1976B2292F1CC19B9c946fC6A7968B0",
                logo: SurfDummy_LOGO,
                decimals: 18
            }
        ],
        supportedUniSwapTokens: [
            {
                name: "IOTA",
                address: "", // This is the address that UniSwap implements for wMatic //0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889
                logo: IotaLogo,
                decimals: 18
            },
            {
                name: "USDC",
                address: "",
                logo: USDC_LOGO,
                decimals: 6
            }
        ],
        logo: IotaLogo
    },
};

// Define the Chain IDs for each network
export const chainConnectionsIds = [
    CHAIN_IDS.ETHEREUM,
    CHAIN_IDS.POLYGON,
    CHAIN_IDS.BSC,
    CHAIN_IDS.TAIKO,
    CHAIN_IDS.MANTA,
    CHAIN_IDS.AVALANCHE,
    CHAIN_IDS.ARBITRUM,
    CHAIN_IDS.LINEA,
    CHAIN_IDS.METIS,
    CHAIN_IDS.OPTIMISM,
    CHAIN_IDS.POLYGONZKEVM,
    CHAIN_IDS.ZKSYNCERA,
    CHAIN_IDS.SCROLL,
    CHAIN_IDS.FUTURVERSE,
    CHAIN_IDS.MANTLE,
    CHAIN_IDS.BASE,
    CHAIN_IDS.FANTOM,
    CHAIN_IDS.CELO,
    CHAIN_IDS.OASIS_SAPPHIRE,
    CHAIN_IDS.EVMOS,
    CHAIN_IDS.CRONOS,
    CHAIN_IDS.ASTAR,
    CHAIN_IDS.IOTAEVM
];

//export const dAppGlobalHash = "0x5d1006d6c79bf00087d1adc65fdb9cd093960d335e35cc08039a90ecdbff8936"

// As we have the SSL certificate, we have to connect to the SSL domain
export const backend = "https://playground.surfermonkey.io:3001/"


// For local dev:
//export const backend = "http://localhost:3001/"